import { render, staticRenderFns } from "./SingleBasicInformationSkeleton.vue?vue&type=template&id=09f24e14&"
import script from "./SingleBasicInformationSkeleton.vue?vue&type=script&lang=js&"
export * from "./SingleBasicInformationSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./SingleBasicInformationSkeleton.vue?vue&type=style&index=0&id=09f24e14&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports